import { makeStyles } from "@mui/styles";
import AccentButton from "components/disw/AccentButton";
import BaseButton from "components/disw/BaseButton";
import React from "react";
import { Link } from "react-router-dom";
import theme from "utils/theme";
import { createRoute } from "utils/url";

const useStyles = makeStyles({
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    padding: theme.spacing(0, 2),
    width: "100%"
  },
  link: {
    display: "inline-flex",
    textDecoration: "none"
  }
});

interface FormActionsProps {
  isSubmitting: boolean;
  solutionKey: string;
}

const FormActions: React.FC<FormActionsProps> = ({
  isSubmitting,
  solutionKey
}) => {
  const classes = useStyles();
  return (
    <div className={classes.actions}>
      <Link
        className={classes.link}
        to={createRoute(`/solutions/${solutionKey}/service-products`)}
      >
        <BaseButton text="Cancel" type="reset" />
      </Link>
      <AccentButton text="Create" type="submit" disabled={isSubmitting} />
    </div>
  );
};

export default FormActions;
